/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
// // const hideOverlay = () => document.querySelector("#modal-contact-dark-overlay").style.display = "none";
//   const hideModal = () => document.querySelector("#popup-form-container").style.display = "none";  

//  document.getElementById("contact-modal-exit").onclick = function(){
//      // hideOverlay();
//     hideModal();
//   }

// document.getElementById('contact-form').addEventListener('submit', function(event) {
//   // Prevent the default form submission behavior
//   event.preventDefault();

//   // Show the success message pop-up container
//   document.getElementById('success-popup-container').style.display = 'block';
function callAPI1()
  {
    console.log("find");
     callAPI();
  }
 function callAPI() {
var settings = {
  "url": "https://b-randcart.myshopify.com/admin/api/2023-04/customers/6989892682023.json",
  "method": "GET",
  "timeout": 0,
  "headers": {
    "Content-Type": "application/json",
    "X-Shopify-Access-Token": "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"
  },
};

$.ajax(settings).done(function (response) {
   document.getElementById("RResponse").innerText = JSON.stringify(response);
  // console.log(response);
});
 }


 // function callAPI() {
 //      // Make an AJAX request to the API
 //      $.ajax({
 //        url: "https://catfact.ninja/fact", // Replace with your API endpoint URL
 //        method: "GET",
 //        success: function(response) {
 //          // Display the response in the 'response' div
 //          document.getElementById("RResponse").innerText = JSON.stringify(response);
 //        },
 //        error: function(xhr, status, error) {
 //          // Handle the error case
 //          console.error("API request failed:", error);
 //        }
 //      });
 //    }



//  function callAPI() {
//   var requestBody = {
//     "id": 1,
//     "method": "SerpstatDomainProcedure.getDomainsInfo",
//     "params": {
//       "domains": ["amazon.in"],
//       "se": "g_in"
//     }
//   };

//   // Make an AJAX request to the API
//   $.ajax({
//     url: "https://api.serpstat.com/v4/?token=83bfddadf0761468e707187475073333", // Replace {token} with your actual API token
//     method: "POST",
//     data: JSON.stringify(requestBody), // Convert the request body to JSON string
//     contentType: "application/json", // Set the content type as JSON
//     success: function(response) {
//       // Display the response in the 'response' div
//       document.getElementById("RResponse").innerText = JSON.stringify(response);
//     },
//     error: function(xhr, status, error) {
//       // Handle the error case
//       console.error("API request failed:", error);
//     }
//   });
// }

//Search tags in product description

document.addEventListener('DOMContentLoaded', function() {
  var searchButtons = document.getElementsByClassName('search-button');

  // Attach click event listener to each button
  Array.prototype.forEach.call(searchButtons, function(button) {
    button.addEventListener('click', function() {
      var searchTerm = this.innerText;
      searchProducts(searchTerm);
    });
  });

  // Function to perform the search /search?type=product&q=
  function searchProducts(searchTerm) {
    // Modify this URL to match your Shopify store's search URL
    var searchUrl = '/search?type=product&q=' + encodeURIComponent(searchTerm);
    window.location.href = searchUrl;
  }
     setTimeout(function(){
             if(typeof SECOMAPP  !== 'undefined' && SECOMAPP.cs.loadedJs){
                console.log('currency switcher');
                Currency.convertAll(Currency.shopCurrency, Currency.currentCurrency);
              }
            },1000);
});




        // // Bar Chart
        // var barCtx = document.getElementById('barChart').getContext('2d');
        // new Chart(barCtx, {
        //     type: 'bar',
        //     data: {
        //         labels: ['Label 1', 'Label 2', 'Label 3'],
        //         datasets: [{
        //             label: 'Bar Chart',
        //             data: [10, 20, 30],
        //             backgroundColor: 'rgba(75, 192, 192, 0.6)'
        //         }]
        //     }
        // });

        // // Pie Chart
        // var pieCtx = document.getElementById('pieChart').getContext('2d');
        // new Chart(pieCtx, {
        //     type: 'pie',
        //     data: {
        //         labels: ['Label 1', 'Label 2', 'Label 3'],
        //         datasets: [{
        //             label: 'Pie Chart',
        //             data: [40, 30, 20],
        //             backgroundColor: ['rgba(255, 99, 132, 0.6)', 'rgba(54, 162, 235, 0.6)', 'rgba(255, 206, 86, 0.6)']
        //         }]
        //     }
        // });

        // // Line Graph
        // var lineCtx = document.getElementById('lineChart').getContext('2d');
        // new Chart(lineCtx, {
        //     type: 'line',
        //     data: {
        //         labels: ['Label 1', 'Label 2', 'Label 3', 'Label 4', 'Label 5'],
        //         datasets: [{
        //             label: 'Line Graph',
        //             data: [50, 30, 40, 20, 35],
        //             borderColor: 'rgba(255, 159, 64, 1)',
        //             backgroundColor: 'rgba(255, 159, 64, 0.2)'
        //         }]
        //     }
        // });
(function() {
    const checkDone = setInterval(function(){
      if (document.readyState == "complete") {
        clearInterval(checkDone)
        setTimeout(function(){
              if(typeof SECOMAPP  !== 'undefined'){
                console.log('currency switcher');
                Currency.convertAll(Currency.shopCurrency, Currency.currentCurrency);
              }
        },1000);
      }
    }, 1500);
    let pushState = history.pushState;
    let replaceState = history.replaceState;

    history.pushState = function() {
      pushState.apply(history, arguments);
      window.dispatchEvent(new Event('pushstate'));
      window.dispatchEvent(new Event('locationchange'));
    };

    history.replaceState = function() {
      replaceState.apply(history, arguments);
      window.dispatchEvent(new Event('replacestate'));
      window.dispatchEvent(new Event('locationchange'));
    };

    window.addEventListener('popstate', function() {
      window.dispatchEvent(new Event('locationchange'))
    });
  })();
  window.addEventListener('locationchange', function(){
    setTimeout(function(){
          if(typeof SECOMAPP  !== 'undefined' ){
                console.log('currency switcher');
                Currency.convertAll(Currency.shopCurrency, Currency.currentCurrency);
              }
    },1000);
  })
